/// <amd-module name="Test/MetadataHandler/Actions/FilterMetadataActions" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { Action } from "VSS/Reflux/Action";

export class FilterMetadataActions {
    public updateStageIdToNameMapAction: Action<{ [key: string]: string }> = new Action<{ [key: string]: string }>();
    public updateFilterFieldValuesForTestResultsAction: Action<TCMContracts.FieldDetailsForTestResults> = new Action<
        TCMContracts.FieldDetailsForTestResults
    >();
    public onError: Action<Error> = new Action<Error>();
}
